// @flow

import { Input, Message, Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import * as React from "react";
import { isPostalCode } from "Commons/Utilities/validators";
import { GoogleTagManager } from "../../../Utilities";
import { oldShortOfferFormStepProgression } from "Commons/Utilities/GoogleTagManager";

import type { PostalInputPropsT, EventT } from "./Types";

let PostalCodeInput = ({
  placeholder,
  meta,
  input,
  custom,
  profile,
  resetLocations,
  change,
  resetSection,
  fetchLocations,
  categorySlug,
  locations,
  compact,
  tags,
}: PostalInputPropsT) => {
  const showError = meta.touched && !!meta.error && meta.invalid;
  return (
    <Grid.Column style={compact ? {} : { paddingBottom: "1rem" }}>
      <Grid.Row>
        <Input
          autoComplete="anyrandomstring"
          id={"postalcode"}
          data-cy={"postalcode"}
          style={{ width: "100%" }}
          className={profile ? "profile-input" : ""}
          placeholder={placeholder}
          {...input}
          {...custom}
          onBlur={(props: EventT) => {
            input.onBlur();
            if (props.target.value.length !== 5) {
              resetLocations();
              change("location", null);
              change("locationId", null);
              change("locationMainName", null);
              change("locationPartName", null);
              change("street", null);
              resetSection(
                "tariffs",
                "tariffId",
                "companyId",
                "companyName",
                "permanentTariffId",
                "tariffName",
                "categoryProviderId"
              );
            }
          }}
          onChange={(e) => {
            change("postalcode", e.target.value);
            if (isPostalCode(e.target.value) === undefined && e.target.value) {
              tags && tags?.gtmEvent && oldShortOfferFormStepProgression(tags?.gtmEvent);
              GoogleTagManager.postalCodeGiven();
              fetchLocations(e.target.value, categorySlug, meta.form, "postalcode");
            } else if (isPostalCode(e.target.value) !== undefined && locations && Object.keys(locations).length > 0) {
              resetLocations();
              change("location", null);
              change("locationId", null);
              change("locationMainName", null);
              change("locationPartName", null);
              change("street", null);
              resetSection(
                "tariffs",
                "tariffId",
                "companyId",
                "companyName",
                "permanentTariffId",
                "tariffName",
                "categoryProviderId"
              );
            }
          }}
          error={showError}
        />
      </Grid.Row>
      {showError && (
        <Grid.Row>
          <Message className={"profile-input"} style={{ marginTop: "1rem" }} negative content={meta.error} />
        </Grid.Row>
      )}
    </Grid.Column>
  );
};

const mapStatetoProps = ({ user: { user }, locations: { locations } }) => ({ locations });

export default PostalCodeInput = connect(mapStatetoProps)(PostalCodeInput);
